export default __webpack_public_path__ + "static/media/img-intro.3138dcf8.png";